import React from 'react';
import footer_logo from "./images/footer_logo.svg";
import facebook from "./images/facebook.svg";
import instagram from "./images/instagram.svg";
import linkedin from "./images/linkedin.svg";
import footer_lines from "./images/footer_lines.svg";
import {motion} from "framer-motion";

const Footer = ({mode}) => {


    const initial = {opacity: 0, y: 30}
    const whileInView = {opacity: 1, y: 0}
    const transition = {duration: 0.8, ease: "easeOut"}
    const viewport = {once: true, amount: 0.3}

    const motionProps = {
        initial,
        whileInView,
        transition,
        viewport
    };


    return (
        <div className="footer_full">
            <div className="footer">
                <img src={footer_lines} alt="" className="footer_lines"/>
                <div className="footer_menu">
                    <a href = {mode === "lite" ? "/presentation" : "/core"}><img src={footer_logo} alt="" className="footer_logo"/></a>
                    <div className="footer_main_menu">
                        <div className="footer_items">

                            <div className="footer_menu_item">


                                <a href = {mode === "lite" ? "/presentation" : "/core"}>
                                    Overview
                                </a>
                            </div>
                            <div className="footer_menu_item">
                                <a href = "/for-issuers#whiteLabel"> White-Label Model Solutions</a>
                            </div>
                            <div className="footer_menu_item">
                                <a href = "/core#core-components">How it works</a>
                            </div>
                            <div className="footer_menu_item">
                                <a href = "/for-issuers#pricing-factors">Pricing</a>
                            </div>
                        </div>
                        <div className="footer_items">
                            <div className="footer_menu_item">
                               <a href = "/presentation"> Undura Lite </a>
                            </div>
                            <div className="footer_menu_item">
                                <a href = "/presentation">  About</a>
                            </div>
                            <div className="footer_menu_item">
                                <a href = "/core#about-undura">Our Mission</a>
                            </div>
                            <div className="footer_menu_item">
                                Contact
                            </div>
                        </div>{/*
                        <div className="footer_items">
                            <div className="footer_menu_item">
                                Technical Documentation
                            </div>
                            <div className="footer_menu_item">
                                Compliance Documents
                            </div>
                            <div className="footer_menu_item">
                                Whitepapers & Reports
                            </div>
                        </div>
                        */}
                    </div>
                    <div className="footer_society_block">
                        {/*<div className="society_item">
                            <img src={facebook} alt=""/>
                            Follow us on Facebook
                        </div>
                        <div className="society_item">
                            <img src={instagram} alt=""/>
                            Follow us on Instagram
                        </div> */}
                        <a href="https://www.linkedin.com/in/ivan-negoda" target = "_blank">
                       <div className="society_item">

                            <img src={linkedin} alt=""/>
                            Follow us on LinkedIn

                        </div></a>
                    </div>
                </div>
                <div className="footer_about_undura">
                    © 2025 Undura. Built for transparency.
                </div>
            </div>
        </div>
    );
};

export default Footer;